import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)<{
  containerWidth: number
  isLastStripe: boolean
  short: string
  xPosition?: number
  yPosition?: number
}>`
  position: absolute;
  width: 256px;
  min-width: 256px;
  height: 108px;
  left: 20px;
  padding: ${theme.spacing.small}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};
  background: ${theme.colors.surfaceContainerBackground};
  box-shadow: 4px 4px 12px 0 rgba(41, 33, 40, 0.32);

  ${({ short }) =>
    short &&
    short === 'true' &&
    `
      width: 168px;
    `};

  ${({ xPosition, isLastStripe, containerWidth, short }) =>
    xPosition && xPosition < 150
      ? `
        left: calc(${xPosition}px - 80px);
      `
      : isLastStripe && short && short === 'true'
      ? `
        left: calc(${containerWidth}px - 185px);
      `
      : isLastStripe
      ? `
        left: calc(${containerWidth}px - 275px);
      `
      : xPosition && xPosition >= 0
      ? `
      left: calc(${xPosition}px - ${short && short === 'true' ? 90 : 129}px);
    `
      : `
      display: none;
    `}

  ${({ yPosition }) =>
    yPosition &&
    yPosition === 4 &&
    `
      top: 4px;
    `}
  
  ${({ yPosition }) =>
    yPosition &&
    yPosition === 3 &&
    `
      top: calc(101.4px + 15px);
    `}
  
  ${({ yPosition }) =>
    yPosition &&
    yPosition === 2 &&
    `
      top: calc(101.4 * 2px + 25px);
    `}
  
  ${({ yPosition }) =>
    yPosition &&
    yPosition === 1 &&
    `
      top: calc(101.4 * 3px + 30px);
    `}
  
  p {
    margin: 0;
  }

  .label-card__content {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xSmall}px;
    flex-grow: 1;
    width: 100%;

    .label-card__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      gap: ${theme.spacing.xSmall}px;

      .label-card__header-title-wrapper {
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xSmall}px;
      }

      svg {
        min-width: 18px;
      }

      .label-card__header-text {
        text-align: center;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.extraThick};
        line-height: 20px;
        letter-spacing: 0.1px;
      }

      .label-card__actions {
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xSmall}px;

        .action-icon-button {
          padding: 0;
        }
      }
    }

    .label-card__text {
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.medium};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 16px;
      letter-spacing: 0.5px;
      word-break: break-word;
      color: ${theme.colors.devicesSecondaryText};
      /* Truncate 1 lines of text */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .label-card__subtext-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .label-card__subtext {
        color: ${theme.colors.textCaption};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.medium};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 16px;
        letter-spacing: 0.5px;
      }
    }
  }
`

export const dropdownMenuSx = {
  '& .MuiPaper-root': {
    borderRadius: '12px',
    boxShadow: '0px 4px 8px 0px rgba(30, 26, 29, 0.20)',
    padding: 0,
    width: '91px',
    background: `${theme.colors.surfaceContainerBackground}`,

    '.MuiList-root': {
      padding: 0,

      '.MuiMenuItem-root': {
        color: `${theme.colors.white}`,
        fontFamily: `${theme.typography.fontFamily.primary}`,
        fontSize: `${theme.typography.fontSize.large}`,
        fontStyle: 'normal',
        fontWeight: `${theme.typography.fontWeight.bold}`,
        lineHeight: '22px',
        paddingLeft: `${theme.spacing.small}px`,
        background: `${theme.colors.surfaceContainerBackground}`,

        '&:first-of-type': {
          paddingTop: '12px'
        },

        '&:last-of-type': {
          paddingBottom: '12px'
        },

        '&:hover': {
          background: `${theme.colors.borderMedium}`
        }
      }
    }
  }
}
